import { useEffect, useState } from 'react'
import { adsService, commonService } from '../services'

const useAds = (option: 'FILTER' | 'BYID' | 'GENDERS' | '' = '', adId?: number) => {
  const [data, setData] = useState<any | null>(null)
  const [dataLoad, setDataLoad] = useState<boolean>(true)

  useEffect(() => {
    if(option === 'FILTER') getAdsSearch()
    else if(option === 'BYID') getAdById(adId ? adId : 0)
    else if(option === 'GENDERS') getGenders()
    else getAds()
  }, [option, adId])

  const getAds = async () => {
    setData(null)
    const resp = await adsService.getAds()
    setData(resp.data)
  }

  const getAdsSearch = async (filter: string = '', page: number = 1) => {
    setDataLoad(true)
    const resp = await adsService.getAdsSearch(filter, page)
    setData(resp.data)
    setDataLoad(false)
  }

  const getAdById = async (adId: number) => {
    const resp = await adsService.getAdById(adId)
    setData(resp.data)
  }

  const getGenders = async () => {
    const resp: any = await commonService.getGenders()
    setData([
      ...resp.data,
      {
        id: 0,
        name: 'Todos',
        status: true
      }
    ])
  }

  const delAd = async (adId: number) => {
    setDataLoad(true)
    const resp = await adsService.delAd(adId)
    setDataLoad(false)
    return resp
  }

  const enableAd = async (adId: number) => {
    setDataLoad(true)
    const resp = await adsService.enableAd(adId)
    setDataLoad(false)
    return resp
  }

  return {
    data,
    dataLoad,
    getAds,
    getAdsSearch,
    getAdById,
    getGenders,
    delAd,
    enableAd
  }
}

export { useAds }